import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage{
  username: string = '';
  password: string = '';
  areCredentialsValid:boolean = true;
  modelList: any[] | undefined;

  constructor(private router:Router,private apiService:ApiService){}

  getModelList(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const lang = 'nl';
      this.apiService.getModelList(lang).subscribe(
        (response) => {
          console.log("response is:", response);
          if (response && Array.isArray(response) && response.length > 0) {
            this.modelList = response;
            localStorage.setItem('selectedModel', response[0]);
            resolve(response[0]); // Resolve with the data
          } else {
            console.log('No data returned or an error occurred.');
            resolve([]); // Resolve with an empty array
          }
        },
        (err) => {
          console.log(err);
          reject(err); // Reject in case of an error
        }
      );
    });
  }

  async login() {
    
      try {
        const res: any = await this.apiService.loginUser(this.username,this.password).toPromise();
        this.getModelList();
        console.log(res);
        localStorage.setItem('selectedModelLanguageForTTS','nl')
        localStorage.setItem('selectedFilterValueForTTS','all')
        localStorage.setItem('authenticationKey', res.AuthenticationKey);
        localStorage.setItem('accent', res.Accent);
        localStorage.setItem('age', res.Age);
        localStorage.setItem('gender', res.Gender);
        localStorage.setItem('userId', res.UserId);
        localStorage.setItem('userName', res.UserName);
        localStorage.setItem('language', 'nl');
        localStorage.setItem('textCategory', 'all');
        
        localStorage.setItem('userRole', res.Role); //STCAI-297

        this.areCredentialsValid = true;
        await this.router.navigate(['/menu']);
      } catch (error: any) {
        console.error("Login Failed",error);
        this.areCredentialsValid = false; 
        setTimeout(() => {
          this.areCredentialsValid = true;
      }, 2000);
      } 
    
  }

 
  navigateToRegistration() {
    // Navigate to the registration page when the registration button is clicked
    this.router.navigate(['/register']);
  }



 }